import React, { useEffect, useMemo, useState } from "react";
import { Container, Button, Form, Row, Col, Alert, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { formatNumber } from "../../../Utils/formatNumber";
import {
  insertCheque,
  updateCheque,
  getChequeById,   // 👈 NECESARIO
} from "../../../Api/ChequesApi";

import ProveedorChequeModal from "./ProveedorChequeModal";
import ProfesionalChequeModal from "./ProfesionalChequeModal";

/* =========================
   ESTADO INICIAL
========================= */
const initialForm = {
  orden: "",
  numeroderecibo: "",
  saldoanterior: "",
  deposito: "",
  total: "",
  saldo: "",
  fechaemision: "",
  nombre: "",
  monto: "",
  concepto: "",
  obs: "",
  idordendepago: "",
  idliquidacion: "",
  motivodeanulado: "",
};

const ChequeFormPage = () => {
  const { id } = useParams();               // 👈 id desde la URL
  const navigate = useNavigate();

  const [form, setForm] = useState(initialForm);
  const [cheque, setCheque] = useState(null);
  const [loading, setLoading] = useState(!!id);

  const [showProveedor, setShowProveedor] = useState(false);
  const [showProfesional, setShowProfesional] = useState(false);

  /* =========================
     CARGAR CHEQUE (EDICIÓN)
  ========================= */
  useEffect(() => {
    if (!id) return;

    const loadCheque = async () => {
      try {
        const data = await getChequeById(id);
        setCheque(data);
        setForm({ ...initialForm, ...data });
      } catch (err) {
        alert(err.message || "Error al cargar el cheque");
        navigate("/cheques");
      } finally {
        setLoading(false);
      }
    };

    loadCheque();
  }, [id, navigate]);
  useEffect(() => {
    if (cheque) {
      setForm({
        ...initialForm,
        ...cheque,
        fechaemision: cheque.fechaemision
          ? String(cheque.fechaemision).split("T")[0]
          : "",
        idordendepago: cheque.idordendepago ?? "",
        idliquidacion: cheque.idliquidacion ?? "",
      });
    } else {
      setForm(initialForm);
    }
  }, [cheque]);
  /* =========================
     REGLA DE EDICIÓN
  ========================= */
  const esEditable = !cheque || cheque.estado === "CREADO";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  /* =========================
     AUTOCOMPLETAR DESDE MODALES
  ========================= */
  const aplicarProveedor = (p) => {
    setForm((prev) => ({
      ...prev,
      nombre: p.razonsocial || p.proveedor,
      numeroderecibo: p.factura || "",        // 👈 ACÁ
      concepto: `Pago proveedor - Factura ${p.factura}`,
      monto: p.monto,
      idordendepago: p.idordendepago || "",
      idliquidacion: "",
    }));
    setShowProveedor(false);
  };


  const aplicarProfesional = (f) => {
    setForm((prev) => ({
      ...prev,
      nombre: f.Nombre,
      numeroderecibo: f.numerofactura || "",  // 👈 ACÁ
      concepto: `Honorarios profesionales - Factura ${f.numerofactura}`,
      monto: f.monto,
      idordendepago: f.idordendepago || "",
      idliquidacion: f.idliquidacion || "",
    }));
    setShowProfesional(false);
  };


  /* =========================
     VALIDACIÓN
  ========================= */
  const isFormValid = useMemo(() => {
    if (!esEditable) return true;

    return (
      form.fechaemision &&
      form.nombre &&
      Number.isInteger(Number(form.monto)) &&
      form.concepto &&
      form.obs
    );
  }, [form, esEditable]);

  /* =========================
     GUARDAR
  ========================= */
  const handleSubmit = async () => {
    if (!isFormValid) return;

    const payload = {
      ...form,
      monto: Number(form.monto),
      saldoanterior: Number(form.saldoanterior) || 0,
      total: Number(form.total) || 0,
      saldo: Number(form.saldo) || 0,
    };

    try {
      if (id) {
        await updateCheque(id, payload);
      } else {
        await insertCheque(payload);
      }

      navigate("/cheques"); // 👈 volver al listado
    } catch (err) {
      alert(err.message || "Error al guardar cheque");
    }
  };

  /* =========================
     LOADING
  ========================= */
  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }
const handleClearForm = () => {
  setForm(initialForm);
};
  return (
    <Container fluid className="mt-4">
      <h4>{id ? "Detalle de Cheque" : "Nuevo Cheque"}</h4>

      {!esEditable && (
        <Alert variant="info">
          Este cheque está en estado <b>{cheque?.estado}</b> y no puede editarse.
        </Alert>
      )}

      {cheque?.estado === "ANULADO" && (
        <Alert variant="danger">
          <Form.Group>
            <Form.Label>Motivo de Anulación</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={form.motivodeanulado}
              disabled
            />
          </Form.Group>
        </Alert>
      )}

      <Form>
        <Row>
          {/* ================= IZQUIERDA ================= */}
          <Col md={4} style={{ borderRight: "1px dashed #ccc" }}>
            <h6 className="text-muted mb-3">Datos administrativos</h6>

            <Form.Group className="mb-2">
              <Form.Label>Orden</Form.Label>
              <Form.Control
                name="orden"
                value={form.orden}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>N° de Recibo</Form.Label>
              <Form.Control
                name="numeroderecibo"
                value={form.numeroderecibo}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Saldo Anterior</Form.Label>
              <Form.Control
                type="number"
                name="saldoanterior"
                value={form.saldoanterior}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Depósito</Form.Label>
              <Form.Control
                name="deposito"
                value={form.deposito}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Total</Form.Label>
              <Form.Control
                type="number"
                name="total"
                value={form.total}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Saldo</Form.Label>
              <Form.Control
                type="number"
                name="saldo"
                value={form.saldo}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <hr />

            <Button
              className="me-2 mb-2"
              variant="outline-primary"
              disabled={!esEditable}
              onClick={() => setShowProfesional(true)}
            >
              Traer Enfermero
            </Button>

            <Button
              className="mb-2"
              variant="outline-success"
              disabled={!esEditable}
              onClick={() => setShowProveedor(true)}
            >
              Traer Proveedor
            </Button>
          </Col>

          {/* ================= DERECHA ================= */}
          <Col md={8}>
            <h6 className="mb-3">Cheque</h6>

            <Form.Group className="mb-2">
              <Form.Label>Fecha de Emisión *</Form.Label>
              <Form.Control
                type="date"
                name="fechaemision"
                value={form.fechaemision}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Páguese a la orden de *</Form.Label>
              <Form.Control
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Monto (Gs) *</Form.Label>
              <Form.Control
                type="text"
                name="monto"
                value={formatNumber(form.monto)}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    monto: e.target.value.replace(/\./g, ""),
                  }))
                }
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Concepto *</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="concepto"
                value={form.concepto}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Observaciones *</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="obs"
                value={form.obs}
                onChange={handleChange}
                disabled={!esEditable}
              />
            </Form.Group>

            <hr />
            <h6 className="text-muted">Vinculación (opcional)</h6>

            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>ID Orden de Pago</Form.Label>
                  <Form.Control
                    type="number"
                    name="idordendepago"
                    value={form.idordendepago}
                    onChange={handleChange}
                    disabled={!esEditable}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>ID Liquidación</Form.Label>
                  <Form.Control
                    type="number"
                    name="idliquidacion"
                    value={form.idliquidacion}
                    onChange={handleChange}
                    disabled={!esEditable}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <div className="mt-3">
        <Button
          variant="secondary"
          className="me-2"
          onClick={() => navigate("/cheques")}
        >
          Volver
        </Button>
  {/* 🔄 LIMPIAR SOLO EN NUEVO CHEQUE */}
  {!id && (
    <Button
      variant="outline-danger"
      className="me-2"
      onClick={handleClearForm}
    >
      Limpiar todo
    </Button>
  )}
        {esEditable && (
          <Button disabled={!isFormValid} onClick={handleSubmit}>
            Guardar Cheque
          </Button>
        )}
      </div>

      {/* ================= MODALES ================= */}
      <ProveedorChequeModal
        show={showProveedor}
        onHide={() => setShowProveedor(false)}
        onSelect={aplicarProveedor}
      />

      <ProfesionalChequeModal
        show={showProfesional}
        onHide={() => setShowProfesional(false)}
        onSelect={aplicarProfesional}
      />
    </Container>
  );

};

export default ChequeFormPage;
